<!-- Footer -->
<p class="clearfix mb-0">
  <span class="float-md-left d-block d-md-inline-block mt-25">
    COPYRIGHT &copy; {{ year }}
    <a class="ml-25" href="https://www.clinicasanjudastadeo.com.pe/" target="_blank">Clínica San Judas Tadeo</a>
    <span class="d-none d-sm-inline-block">, Todos los derechos reservados</span>
  </span>
  <span class="float-md-right d-none d-md-block">
    Tu Bienestar Es Nuestra Meta <span [data-feather]="'heart'" [class]="'pink'"></span>
  </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>


